<span class="page-placeholder__icon" aria-hidden="true">{{ icon }}</span>
<h1 class="page-placeholder__title">{{ title | translate }}</h1>
<p class="page-placeholder__subtitle">{{ subtitle | translate }}</p>
<span class="page-placeholder__badge">{{ badge | translate }}</span>
